import { api, setTokens, clearTokens } from './client';

export const authApi = {
  register: (data) => api.post('/auth/register', data).then((r) => r.data),
  verifyEmail: (data) => api.post('/auth/verify-email', data).then((r) => r.data),
  resendCode: (data) => api.post('/auth/resend-code', data).then((r) => r.data),
  login: (data) => api.post('/auth/login', data).then((r) => r.data),
  google: (idToken) => api.post('/auth/google', { idToken }).then((r) => r.data),
  logout: async () => {
    const refresh = localStorage.getItem('gf_refresh');
    try {
      if (refresh) await api.post('/auth/logout', { refreshToken: refresh });
    } finally {
      clearTokens();
    }
  },
  me: () => api.get('/auth/me').then((r) => r.data),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }).then((r) => r.data),
  resetPassword: (data) => api.post('/auth/reset-password', data).then((r) => r.data),
  changePassword: (data) => api.post('/auth/change-password', data).then((r) => r.data),
};

// Persistencia
export const persistSession = (data) => {
  setTokens({ access: data.access, refresh: data.refresh });
  if (data.user) localStorage.setItem('gf_user', JSON.stringify(data.user));
};

export const getStoredUser = () => {
  try { return JSON.parse(localStorage.getItem('gf_user')); } catch { return null; }
};